export const VAT_RATE = 0.19;
export const DEFAULT_TIMEZONE = "Europe/Berlin";
export const distanceGeo = (p1, p2) => distance(p1.lat, p1.lng, p2.lat, p2.lng);

export const distance = (lat1, lng1, lat2, lng2) => {
  if (lat1 === lat2 && lng1 === lng2) {
    return 0;
  } else {
    const radlat1 = (Math.PI * lat1) / 180;
    const radlat2 = (Math.PI * lat2) / 180;
    const theta = lng1 - lng2;
    const radtheta = (Math.PI * theta) / 180;
    let dist =
      Math.sin(radlat1) * Math.sin(radlat2) +
      Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    if (dist > 1) {
      dist = 1;
    }
    dist = Math.acos(dist);
    dist = (dist * 180) / Math.PI;
    dist = dist * 60 * 1.1515;
    dist = dist * 1.609344;
    return dist;
  }
};

export const vat = res => ((res / (1 + VAT_RATE)) * VAT_RATE).toFixed(2);

export const isToday = d => {
  const today = new Date();
  return (
    d.getDate() === today.getDate() &&
    d.getMonth() === today.getMonth() &&
    d.getFullYear() === today.getFullYear()
  );
};

export const isSameDate = (d1, d2) =>
  d1.getFullYear() === d2.getFullYear() &&
  d1.getMonth() === d2.getMonth() &&
  d1.getDate() === d2.getDate();

export const isSameGeoLocation = (l0, l1) => l0 && l1 && l0.lat === l1.lat && l0.lng === l1.lng;

/* A position only counts when it carries both coordinates. An object with the keys present but
   empty is not one, which lodash's isEmpty cannot tell, and handing it to Leaflet throws. */
export const hasPosition = position =>
  !!position &&
  Number.isFinite(parseFloat(position.lat)) &&
  Number.isFinite(parseFloat(position.lng));
